import { configureStore } from '@reduxjs/toolkit'
import peshbinisSlice from '../slice/peshbinisSlice'
import themeSlice from '../slice/themeSlice'
import userSlice from '../slice/userSlice'
import userxalSlice from '../slice/userxalSlice'


export const store = configureStore({
  reducer: {
    user:userSlice,
    peshbinis:peshbinisSlice,
    theme:themeSlice,
    xals:userxalSlice
  },
})